// PROD-9786: why a deduction vanished. Only the CMS report carries student_banned (D-20).
export function student_banned_label(row) {
  return row && row.student_banned ? 'Student banned' : '';
}
